<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label">{{ label }}:<span v-if="required" class="text-red-500">*</span></label>
    <div class="flex flex-wrap">
      <div class="flex items-center mr-4" v-for="option in options">
        <label class="wrapper flex items-center" :for="id+option.name+option.value">
          <input class="checkbox" type="radio" :name="id" :id="id+option.name+option.value" :checked="isChecked(option)"
            :value="option.value" v-model="selected" @change="$emit('change', $event.target.value)" :disabled="disabled" />
          <span class="checkmark pr-2"></span>
          {{ option.label }}
        </label>
      </div>
    </div>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  inheritAttrs: false,

  model: {
    prop: 'modelValue',
    event: 'change'
  },
  data() {
    return {
      selected: this.modelValue,
    }
  },
  watch: {
    selected(selected) {
      this.$emit('update:modelValue', selected)
    },
    modelValue(modelValue) {
      this.selected = modelValue;
    },
  },
  props: {
    "modelValue": { default: "" },
    "value": { type: String },
    "disabled": { type: Boolean, default: false },
    options: {
      type: Array
    },
    id: {
      type: String,
      default() {
        return `select-input-${uuid()}`
      },
    },
    error: String,
    label: String,
    required: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isChecked(option) {
      return this.modelValue == option.value
    }
  }
}
</script>
